import React from "react";
import { Link } from "react-router-dom";

import "./NotFoundPage.css";

function NotFoundPage() {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>0</span>4
          </h1>
        </div>
        <h2>خطأ، الصفحة غير موجودة</h2>
        <button className="button notfound-back-btn">
          <Link to="/">
            <h3>العودة للرئيسية</h3>
          </Link>
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
